import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiBell } from 'react-icons/fi';
import styles from './NotificationBell.module.css';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { fetchMyLeads } from '../../features/leads/leadsSlice';
import axiosClient from '../../api/axiosClient';

interface SummaryItem { key: string; label: string; count: number; path: string; }

const NotificationBell: React.FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { myLeads } = useAppSelector((state) => state.leads);
  const [open, setOpen] = useState(false);
  const [summary, setSummary] = useState<{ total: number; items: SummaryItem[] }>({ total: 0, items: [] });

  const isAdmin = user?.role === 'admin';

  useEffect(() => {
    if (isAdmin) {
      axiosClient.get('/admin/notifications/summary').then(({ data }) => setSummary(data)).catch(() => {});
    } else if (user) {
      dispatch(fetchMyLeads());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const count = isAdmin ? summary.total : myLeads.filter((l) => l.status === 'pending').length;
  const recentConfirmed = !isAdmin ? myLeads.filter((l) => l.status === 'confirmed' && l.contact_by).slice(0, 3) : [];
  const activeItems = summary.items.filter((i) => i.count > 0);

  return (
    <div className={styles.wrap}>
      <button type="button" className={styles.bellBtn} onClick={() => setOpen((v) => !v)}>
        <FiBell />
        {count > 0 && <span className={styles.badge}>{count > 9 ? '9+' : count}</span>}
      </button>
      {open && (
        <>
          <div className={styles.overlay} onClick={() => setOpen(false)} />
          <div className={styles.dropdown}>
            <div className={styles.dropdownTitle}>Notifications</div>
            {isAdmin ? (
              activeItems.length > 0 ? (
                activeItems.map((i) => (
                  <Link to={i.path} key={i.key} className={styles.item} onClick={() => setOpen(false)}>
                    <b>{i.count}</b> {i.label}
                  </Link>
                ))
              ) : (
                <div className={styles.empty}>You're all caught up.</div>
              )
            ) : (
              <>
                {count > 0 && (
                  <Link to="/dashboard" className={styles.item} onClick={() => setOpen(false)}>
                    <b>{count}</b> request{count !== 1 ? 's' : ''} pending review
                  </Link>
                )}
                {recentConfirmed.map((l) => (
                  <Link to="/dashboard" key={l.id} className={styles.item} onClick={() => setOpen(false)}>
                    Confirmed — we'll contact you by {new Date(l.contact_by!).toLocaleDateString()}
                  </Link>
                ))}
                {count === 0 && recentConfirmed.length === 0 && <div className={styles.empty}>Nothing new right now.</div>}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationBell;
